// The door for late-born materials to get the dither at birth.
//
// RendererDither patches whatever is in the scene when it mounts, then
// catches strays with a sweep every 180 frames. Anything created after
// mount (a billboard rebuilt on a poll, a drawing hung when its texture
// lands) rendered clean for up to three seconds and then snapped to the
// dithered look, which is exactly the flicker Sam kept seeing on the
// posters. The sweep stays as the safety net; components that make
// materials at runtime call ditherMaterial() at creation and never show
// an unpatched frame.
//
// Module state on purpose: one dither pass per app, and the registry has
// to be reachable from plain component code without threading a context
// through the whole tree.

let patch = null

export function setDitherPatcher(fn) { patch = fn }
export function clearDitherPatcher(fn) { if (patch === fn) patch = null }

/** Patch one material right now, if the pass is live. Safe to call
 *  always: before the pass mounts (or on the webgl fallback) it is a
 *  no-op and the sweep or the backend rules pick things up instead. */
export function ditherMaterial(mat) {
  if (patch && mat) patch(mat)
}
